import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollProgress from '../components/ScrollProgress';
import { mockData } from '../data/mock';

const ImprintPage = () => {
  return (
    <>
      <ScrollProgress />
      <Header />
      <main className="pt-24 pb-16">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold text-neutral-900 mb-8">Impressum</h1>

            <div className="prose prose-lg max-w-none">
              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                Angaben gemäß § 5 TMG
              </h2>
              <p className="text-neutral-600 mb-4">
                Erste-Hilfe Fokus<br />
                {mockData.company.address.street}<br />
                {mockData.company.address.zip} {mockData.company.address.city}<br />
                Deutschland
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                Kontakt
              </h2>
              <p className="text-neutral-600 mb-4">
                Telefon: 0159 0226 8861<br />
                E-Mail: {mockData.company.email}
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                BG Zulassung
              </h2>
              <p className="text-neutral-600 mb-4">
                Kennziffer: 8.0559<br />
                Ermchtigt durch: Med1Plus.de<br />
                Gültig für: Aus- und Fortbildung in Erster Hilfe gemäß DGUV Vorschrift 1
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                Aufsichtsbehörde
              </h2>
              <p className="text-neutral-600 mb-4">
                Qualitätssicherungsstelle Erste Hilfe der gesetzlichen Unfallversicherungsträger
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p className="text-neutral-600 mb-4">
                Erste-Hilfe Fokus<br />
                {mockData.company.address.street}<br />
                {mockData.company.address.zip} {mockData.company.address.city}
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                EU-Streitschlichtung
              </h2>
              <p className="text-neutral-600 mb-4">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a
                  href="https://ec.europa.eu/consumers/odr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-red-600 hover:text-red-700"
                >
                  https://ec.europa.eu/consumers/odr
                </a>
                <br />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                Verbraucherstreitbeilegung / Universalschlichtungsstelle
              </h2>
              <p className="text-neutral-600 mb-4">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                Haftung für Inhalte
              </h2>
              <p className="text-neutral-600 mb-4">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach
                den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
                jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
                überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                Haftung für Links
              </h2>
              <p className="text-neutral-600 mb-4">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
                Seiten verantwortlich.
              </p>

              <h2 className="text-xl font-semibold text-neutral-900 mt-8 mb-4">
                Urheberrecht
              </h2>
              <p className="text-neutral-600 mb-4">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
                dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
                der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
                Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ImprintPage;
